import { render, staticRenderFns } from "./code_album.html?vue&type=template&id=0f500e02&scoped=true&external"
import script from "./code_album.vue?vue&type=script&lang=js"
export * from "./code_album.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f500e02",
  null
  
)

export default component.exports